import React, { Component } from 'react';

//React-PDF dependencies
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import AsyncPdfImage from './AsyncPdfImage';

const styles = StyleSheet.create({
  questionContainer: {
    display: "flex",
    flexDirection: "column",
    margin: '8 0',
    width: "100%",
    question: {
      marginTop: 2,
      fontSize: 11,
      fontWeight: 900,
      fontFamily: 'Roboto',
      maxWidth: 480,
    },
    answer: {
      marginTop: 2,
      background: '#000000',
      opacity: 0.5,
      fontSize: 9,
      fontFamily: 'Roboto',
    },
    column: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      margin: '0 10',
    },
    qNumber: {
      backgroundColor: '#bdbdbd',
      width: 15,
      height: 15,
      alignItems: 'center',
      justifyContent: 'center',
      number: {
        color: 'white',
        fontSize: 10,
        fontFamily: 'Roboto',
      }
    },
  },
  image: {
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
});

class QuestionPdf extends Component {

  render() {
    const { data } = this.props;
    return(
      <View style={styles.questionContainer} wrap={false}>
        <View style={styles.questionContainer.column}>
          <View style={styles.questionContainer.qNumber}>
            <Text style={styles.questionContainer.qNumber.number}>
              {this.props.question.position}
            </Text>
          </View>
          <View style={styles.questionContainer.row}>
            <Text style={styles.questionContainer.question}>
              {"Q. " + this.props.question.statement}
            </Text>
            <Text style={styles.questionContainer.answer}>
                {"A. " + this.props.question.answer}
            </Text>
          </View>
        </View>
        {this.props.question.images.map((tile, id) => (
          <View key={id} style={styles.image.container}>
            <AsyncPdfImage key={id} projectId={tile.project.id} imageId={tile.id} size="1000x1000" data={data}/>
          </View>
        ))}
      </View>
    );
  }
}

export default QuestionPdf;


// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/QuestionPdf.js